import { PAGE_TYPE_CART } from 'shared/consts'
import { TENANT_CH } from 'shared/consts/tenants'
import { CART_WID_REPLACE_FR_CH } from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'
import store from 'shared/store'

export default () => {
  const cartCswChangePlace = getExperimentOnClient(CART_WID_REPLACE_FR_CH)
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const tenant = publicRuntimeConfig.publicConfig.tenant || {}
  const pageType = publicRuntimeConfig?.pageProperties.pageType

  if (
    cartCswChangePlace.isEnabled &&
    tenant === TENANT_CH &&
    pageType === PAGE_TYPE_CART
  ) {
    trackCswSlider({
      shouldTrackWithWidgetIds: true,
    })
  }
}
